<template>
  <router-view />
  <DomainNameUpdate></DomainNameUpdate>
</template>

<script setup>
import DomainNameUpdate from "@/components/activitie/domainNameUpdate.vue";

</script>

<style lang="scss">
#app {
  width: 100vw;
  height: 100vh;
}
</style>
